import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialApplyLoanState: IApplyLoanState = {
  data: {
    helpDesk: [],
    meta: {},
  },
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IApplyLoanState {
  data?: {
    helpDesk?: {[key: string]: number | string}[]
    meta?: {[key: string]: number}
  }
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IApplyLoanState = initialApplyLoanState,
  action: ActionWithPayload<IApplyLoanState>
) => {
  switch (action.type) {
    case actionTypes.GET_HELP_DESK_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_HELP_DESK_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_HELP_DESK_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_HELP_DESK_RESET: {
      return {...state, success: false, data: [], loading: false}
    }

    //update help desk
    case actionTypes.UPDATE_HELP_DESK_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_HELP_DESK_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_HELP_DESK_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.UPDATE_HELP_DESK_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    default:
      return state
  }
}
